var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var SessionController = {
    /*****************************************************************************************************
        * Is using route "api/{groupId}/session/sessions" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @returns {SessionDownloadDto[]}
    ******************************************************************************************************/
    GetSessions: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/{groupId}/session/sessions", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/session/sessions/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {SessionDownloadDto}
    ******************************************************************************************************/
    GetSession: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/session/sessions/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/{groupId}/session/sessions" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {SessionUploadDto} dto
        * @returns {SessionDownloadDto}
    ******************************************************************************************************/
    CreateSession: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/{groupId}/session/sessions", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/session/sessions/{id}" and http method "PUT" to call the back-end.
    
        * @param {string} id
        * @param {SessionUploadDto} dto
        * @returns {SessionDownloadDto}
    ******************************************************************************************************/
    UpdateSession: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/session/sessions/{id}", __assign({}, data)),
            method: "PUT",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/session/sessions/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    DeleteSession: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/session/sessions/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/{groupId}/session/sessionHierarchy" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @returns {SessionTemplateDownloadDto[]}
    ******************************************************************************************************/
    GetSessionHierarchy: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/{groupId}/session/sessionHierarchy", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/{groupId}/session/getResourceUnavailabilities" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string[]} resourceIds
        * @param {Date} notBefore
        * @param {Date} notAfter
        * @returns {Date[]}
    ******************************************************************************************************/
    GetUnavailableDatesForResources: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        var fd = new FormData();
        fd.append("resourceIds", JSON.stringify(data.resourceIds));
        fd.append("notBefore", JSON.stringify(data.notBefore));
        fd.append("notAfter", JSON.stringify(data.notAfter));
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/{groupId}/session/getResourceUnavailabilities", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=SessionController.js.map